interface FeatureFlags {
  [key: string]: {
    showBookNow: boolean;
  };
}

const featureFlags:FeatureFlags = {
  indore: {
    showBookNow: true,
  },
  bhopal: {
    showBookNow: true,
  },
  dewas: {
    showBookNow: true,
  },
  ujjain: {
    showBookNow: true,
  },
  pune: {
    showBookNow: false,
  },
  mhow: {
    showBookNow: true,
  },
  mandsaur: {
    showBookNow: false,
  },
  coimbatore: {
    showBookNow: false,
  },
  delhi: {
    showBookNow: false,
  },
  ahemdabad: {
    showBookNow: false,
  },
  ratlam: {
    showBookNow: false,
  },
  betma: {
    showBookNow: true,
  },
  chennai: {
    showBookNow: false,
  },
  bombay: {
    showBookNow: false,
  },
};

export default featureFlags;
